export const NOT_FOUND = 'NOT_FOUND'

export const SortDirectionType = {
	ASCENDING: 1,
	DESCENDING: 2
}

export const TaskTargetType = {
    Agent: 'agent',
    Utg: 'utg'
}
export const TaskTargetTypeUtg = {
    Configuration: 'configuration',
    DeployUtgVersion: 'deployUtgVersion',
    Miscellaneous: 'miscellaneous',
    SetOffline: 'setOffline',
    StartStop: 'startstop',
    UploadLogs: 'uploadLogs'
}

export const TaskTargetTypeUtgConfiguration = {
    UpdateUtg: 'push',
    RollbackUtg: 'rollback',
    UpdateCommandCenter: 'pull'
}

export const TaskTargetTypeUtgStartStop = {
    Restart: 'restart',
    Start: 'start',
    Stop: 'stop'
}

export const TaskTargetTypeUtgMiscellaneous = {
    ResetSerialSlot: 'resetSerialSlot'
}

export const TaskTargetTypeAgent = {
    DeployAgentVerson: 'deployAgentVersion',
    UploadLogs: 'uploadLogs'
}

export const CreateTaskTypeEnum = {
    unknown: 0,
    start: 1,
    stop: 2,
    restart: 3,
    push: 4, // update config
    rollback: 5, // sync config
    pull: 5, // same as sync but differences are in the task instructions
    updateComponentInfo: 6,
    resetSerialSlot: 7,
    deployUtgVersion: 8,
    deployAgentVersion: 9,
    UpdateDeviceForms: 10,
    UpdateDeviceFirmware: 11,
    setOffline: 13,
    uploadLogs: 15,
}

export const UserRoles = {
	ReadOnly: 10000,
	Manager: 10001,
	TechnicalAdvisor: 10002,
	Technician: 10003,
	HelpDesk:10004
}

export const UserTypes = {
	Standard: 0,
	System: 1,
	Ephemeral: 2
}

export const UserPermissions = {
	canView: 'canView',
	canEdit: 'canEdit',
	canDelete: 'canDelete',
	isEnabled: 'isEnabled',
	canGrant: 'canGrant'
}

export const ComponentDeviceType = {
	Unknown: 0,

	// Ingenico
	iPP320CAN: 1,
	iCM122RBA: 2,
	iMP352RBA: 3,
	iMP627RBA: 4,
	iMP657RBA: 5,
	iPP320RBA: 6,
	iPP350RBA: 7,
	iSC250RBA: 8,
	iSC350RBA: 9,
	iSC480RBA: 10,
	iWL250RBA: 11,
	iWL252RBA: 12,
	iWL258RBA: 13,
	iUP250RBA: 14,
	iUC285RBA: 15,
	L3000RBA: 16,
	L3600RBA: 24,
	L5000RBA: 17,
	L7000RBA: 18,
	L8000RBA: 19,
	LK2500iRBA: 20,
	Link2500: 20,
	M5000RBA: 21,
	Move5000: 21,

	// Verifone
	Mx915P2PE: 22,
	Mx925P2PE: 23,

	Self2000: 25,
	S2000: 25,
	Self2000LE: 25,
	S2000LE: 25,
	Self3000: 26,
	S3000: 26,
	Self4000: 27,
	S4000: 27,
	Self4000LE: 27,
	S4000LE: 27,
	Self5000: 28,
	S5000: 28,
	Self5000LE: 28,
	S5000LE: 28,
	Self70008000: 29,
	S70008000: 29
}

export const ComponentDeviceTypeFormsUnsupported = {
	mx915p2pe: true,
	mx925p2pe: true,
	paxbroadpos: true
}

export const DeviceFilterOptions = [
		{
			name: 'UTG Version',
			field: 'UtgVersion',
			isMultiplePredicates:false,
			type: 'text',
			supportsOperators: true,
			supportsMultiplePredicates: true,
			TypeHint: "Version", operatorOptions: [
				{
					key: "Is Equal to",
					value: "EQ"
				}, {
					key: "Is Not Equal to",
					value: "NEQ"
				}, {
					key: "Is Less than",
					value: "LT"
				}, {
					key: "Is Less than or Equal to",
					value: "LTE"
				}, {
					key: "Is Greater than",
					value: "GT"
				}, {
					key: "Is Greater than or Equal to",
					value: "GTE"
				}
			]
		},
		{
			name: 'Agent Version',
			field: 'AgentVersion',
			isMultiplePredicates: false,
			type: 'text',
			supportsOperators: true,
			supportsMultiplePredicates: true,
			TypeHint: "Version",
			operatorOptions: [
				{
					key: "Is Equal to",
					value: "EQ"
				}, {
					key: "Is Not Equal to",
					value: "NEQ"
				}, {
					key: "Is Less than",
					value: "LT"
				}, {
					key: "Is Less than or Equal to",
					value: "LTE"
				}, {
					key: "Is Greater than",
					value: "GT"
				}, {
					key: "Is Greater than or Equal to",
					value: "GTE"
				}
			]
		},
		{
			name: 'Merchant',
			field: 'ComponentMerchant',
			type: 'text'
		},
		{
			name: 'UTG Nickname',
			field: 'ComponentNickname',
			type: 'text'
		},
		{
			name: 'Profile',
			field: 'ComponentProfileName',
			type: 'text'
		},
		{
			name: 'Profile Version',
			field: 'ComponentProfileVersion',
			type: 'numeric',
			TypeHint: "Integer"
		},
		{
			name: 'Location/Serial',
			field: 'ComponentLocation',
			type: 'text'
		},
		{
			name: 'Lane',
			field: 'ComponentLane',
			type: 'text'
		},
		{
			name: 'File ID',
			field: 'ComponentFileId',
			type: 'text'
		},
		{
			name: 'Machine Status',
			field: 'MachineStatus',
			type: 'text'
		},
		{
			name: 'UTG Status',
			field: 'UtgStatus',
			type: 'text'
		},
		{
			name: 'Firmware Version',
			field: 'DeviceStatusFirmwareVersion',
			isMultiplePredicates: false,
			supportsOperators: true,
			supportsMultiplePredicates: true,
			type: 'text',
			operatorOptions: [
				{
					key: "Is Equal to",
					value: "EQ"
				}, {
					key: "Is Not Equal to",
					value: "NEQ"
				}, {
					key: "Is Less than",
					value: "LT"
				}, {
					key: "Is Less than or Equal to",
					value: "LTE"
				}, {
					key: "Is Greater than",
					value: "GT"
				}, {
					key: "Is Greater than or Equal to",
					value: "GTE"
				}
			]
		},
		{
			name: 'PCI Version',
			field: 'DeviceStatusDevicePciVersion',
			isMultiplePredicates: false,
			supportsOperators: true,
			supportsMultiplePredicates: true,
			type: 'text',
			operatorOptions: [
				{
					key: "Is Equal to",
					value: "EQ"
				}, {
					key: "Is Not Equal to",
					value: "NEQ"
				}, {
					key: "Is Less than",
					value: "LT"
				}, {
					key: "Is Less than or Equal to",
					value: "LTE"
				}, {
					key: "Is Greater than",
					value: "GT"
				}, {
					key: "Is Greater than or Equal to",
					value: "GTE"
				}
			]
		},
		{
			name: 'Device Type',
			field: 'DeviceConfigDeviceType',
			type: 'text'
		},
		{
			name: 'Device Serial',
			field: 'DeviceStatusDeviceSerialNumber',
			type: 'text'
		},
		{
			name: 'Terminal ID',
			field: 'DeviceConfigApiTerminalId',
			type: 'text'
		}
	]

export const UserSettingsType = {
	UtgListFilters: 'previouslySelectedUtgFilters',
	TaskListFilters: 'previouslySelectedTaskFilters',
	DeviceListFilters: 'previouslySelectedDeviceFilters',
	PageSize: 'pagesize',
	ShowTree: 'showtree',
	SidebarWidth: 'sidebarwidth',
	Debug: 'debug',
	SelectedBusinessEntityId: 'selectedBusinessEntityId'
}